import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Portal } from 'components/Portal';
import { Icon } from 'components/Icon';
import { Loader } from 'components/Loader';
import { InputIcon } from 'components/Input';
import { InputAutoComplete } from 'components/InputAutoComplete';
import { ContextMenuTrigger } from 'react-contextmenu';
import './style.scss';

const ModalInstrumentsBase = ({
  articul,
  handleArticul,
  selected,
  search,
  handleSearch,
  searchCategory,
  category,
  stockList,
  contextMenuID,
  toggleCategory,
  handleSearchCategory,
  categoriesList,
  isMainPage,
  handleStock,
  subtype,
  subTypeList,
  handleSubType,
  instrumentsList,
  stock,
  handleSelectItem,
  onClose,
  handleReset,
  canReset,
}) => {
  const [disable, setDisable] = useState(false);

  const onMouseDown = () => {
    setDisable(true);
  };

  const onMouseUp = () => {
    setDisable(false);
  };

  const selectItem = async (inst) => {
    setDisable(true);
    await handleSelectItem(inst);
    setDisable(false);
  };
  return (
    <Portal id="modal-instrument" className="modal-instrument" onClose={onClose}>
      <div className="instrument-categories-menu">
        <div className="modal-title">
          <div className="header-title">Категории</div>
        </div>

        <div className="instruments-search-panel">
          <InputIcon
            icon="search"
            value={searchCategory}
            onChange={handleSearchCategory}
            size="100%"
            placeholder="Наименование..."
          />
        </div>

        {categoriesList === null && (
          <div className="instruments-loader-center">
            <Loader type="small" color="#000" />
          </div>
        )}

        <table className="instruments-list">
          <thead>
            <tr>
              <th className="instruments-header" width="216px" style={{ textAlign: 'left' }}>
                Наименование
              </th>
            </tr>
          </thead>

          <tbody className="body-list dropdownScroll">
            {categoriesList &&
              categoriesList
                .filter((cat) => {
                  const searchReg = new RegExp(searchCategory, 'gi');
                  return searchCategory.length === 0 || searchReg.test(cat);
                })
                .map((cat, i) => (
                  <tr
                    key={cat + i}
                    style={category === cat ? { backgroundColor: '#eef4fd' } : {}}
                    className="instruments-prop"
                    onClick={() => toggleCategory(cat)}
                  >
                    <th className="instruments-row" width="216px" style={{ textAlign: 'left' }}>
                      {cat}
                    </th>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>

      <div className="instrument-main-menu">
        <div className="modal-title">
          <div className="header-title">Номенклатура</div>
        </div>

        <div className="instruments-search-panel">
          <InputIcon icon="search" value={search} onChange={handleSearch} placeholder="Наименование..." />

          <InputIcon
            icon="search"
            style={{ width: '80px' }}
            value={articul}
            onChange={handleArticul}
            placeholder="Артикул..."
          />

          <InputAutoComplete
            icon="search"
            selected={{ value: stock.stockID1C, text: stock.stockName }}
            list={stockList?.map((stockElem) => ({
              text: stockElem.stockName,
              value: stockElem.stockID1C,
              returning: stockElem,
            }))}
            onChange={handleStock}
            className="input-select-group"
            size="130px"
            placeholder="Склад..."
          />

          <InputAutoComplete
            icon="search"
            selected={{ value: subtype, text: subtype }}
            list={subTypeList?.map((subType) => ({
              text: subType,
              value: subType,
            }))}
            className="input-select-group"
            size="120px"
            onChange={handleSubType}
            placeholder="Вид..."
          />

          {canReset() && (
            <div className="reset-main-header" onClick={handleReset}>
              Очистить
            </div>
          )}
        </div>

        {instrumentsList === null && (
          <div className="instruments-loader-center">
            <Loader type="small" color="#000" />
          </div>
        )}

        <table className="instruments-list">
          <thead>
            <tr>
              <th className="instruments-header" style={{ width: '42px' }}>
                &nbsp;
              </th>
              {!stock.stockID1C && (
                <th className="instruments-header" style={{ width: '125px', textAlign: 'left' }}>
                  Склад
                </th>
              )}
              <th className="instruments-header" style={{ width: '325px', textAlign: 'left' }}>
                Наименование
              </th>
              <th className="instruments-header" style={{ width: '95px', justifyContent: 'center'}}>
                Рем.
              </th>
              <th className="instruments-header highlighted" style={{ width: '95px', justifyContent: 'center' }}>
                Ост. (1С)
              </th>
              <th className="instruments-header" style={{ width: '65px', justifyContent: 'center' }}>
                Ост.
              </th>
              <th className="instruments-header" style={{ width: '55px', justifyContent: 'center' }}>
                Рез.
              </th>
              <th className="instruments-header highlighted" style={{ width: '100px', justifyContent: 'center' }}>
                Арен. (1С)
              </th>
              <th className="instruments-header" style={{ width: '65px', justifyContent: 'center' }}>
                Арен.
              </th>
            </tr>
          </thead>

          <tbody className="body-list dropdownScroll">
            {instrumentsList !== null &&
              instrumentsList.map((inst, i) => {
                const isLighted = selected.find((sel) => sel.id === inst.id);

                return (
                  <ContextMenuTrigger
                    id={contextMenuID}
                    key={inst.title + i}
                    renderTag="tr"
                    key={inst.title + i}
                    disableIfShiftIsPressed={true}
                    collect={() => ({ ...inst, stock })}
                    disable={disable}
                    attributes={{
                      onMouseUp: () => onMouseUp(),
                      onMouseDown: () => onMouseDown(),
                      className: 'instruments-prop',
                      style: isLighted ? { backgroundColor: '#eef4fd' } : {},
                      onClick: () => selectItem(inst),
                    }}
                  >
                    <td className="instruments-row" style={{ width: '42px' }}>
                      <Icon name="instrument" style={{ display: 'inline-block' }} />
                    </td>
                    {!stock.stockID1C && (
                      <td className="instruments-row" style={{ width: '125px', textAlign: 'left' }}>
                        {inst.stockName || ''}
                      </td>
                    )}
                    <td className="instruments-row" style={{ width: '325px', textAlign: 'left' }}>
                      {inst.title}
                    </td>
                    <td className="instruments-row highlighted" style={{ width: '95px', justifyContent: 'center' }}>
                      {inst.quantity_left_1C}
                    </td>
                    <td className="instruments-row" style={{ width: '65px', justifyContent: 'center' }}>
                      {inst.quantity_left_service}
                    </td>
                    <td className="instruments-row" style={{ width: '55px', justifyContent: 'center' }}>
                      {inst.quantity_inreserve_service}
                    </td>
                    <td className="instruments-row highlighted" style={{ width: '100px', justifyContent: 'center' }}>
                      {inst.quantity_inrent_1C}
                    </td>
                    <td className="instruments-row" style={{ width: '65px', justifyContent: 'center' }}>
                      {inst.quantity_inrent_service}
                    </td>
                  </ContextMenuTrigger>
                );
              })}
          </tbody>
        </table>
      </div>
    </Portal>
  );
};

ModalInstrumentsBase.propTypes = {
  selected: PropTypes.array,
  isMainPage: PropTypes.bool,
  contextMenuID: PropTypes.string,
  defaultStock: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onAdd: PropTypes.func,
};

ModalInstrumentsBase.defaultProps = {
  selected: [],
  isMainPage: false,
  contextMenuID: 'defaultId',
  defaultStock: { stockID1C: '', stockName: '' },
  onAdd: () => {},
};

export { ModalInstrumentsBase };
